<template>
	<transition name="slide-fade">
		<div>
			<p class="text-yellow">NOTE: This procedure will overwrite the Short Code configuration if duplicated</p>
			<div class="form-group row mb-1">
				<div class="col-sm-3">
					<div class="custom-file">
						<input type="hidden" id="nsimgt-csv-input-file-value">
						<input type="file" accept=".csv" class="custom-file-input" id="nsimgt-csv-input-file" @change="handleFileInputChange">
						<label class="custom-file-label" for="suspend-input-file" id="nsimgt-csv-input-file-label">Choose file</label>
					</div>
				</div>

				<div class="col-sm-9">
<!--					<b-button variant="success" @click="previewData">Preview</b-button>-->
					<b-button variant="primary " @click="uploadCsv" :disabled="!previewDataClicked">Upload Data</b-button>
					<b-button variant="light" @click="downloadCsv">Download Template</b-button>
				</div>
				
			</div>

			<b-row class="mt-2 ,b-3" v-if="false">
				<b-col xl="3" md="3" sm="12">
					
				</b-col>
				<b-col xl="7" md="7" sm="12"></b-col>
				<b-col xl="2" md="2" sm="12" class="text-right">
					<b-button
						size="sm"
						variant="success"
						class="mt-2 mb-3"
						v-b-modal.add-user
						v-b-tooltip.hover
						title="Add User"
					>
						<i class="fas fa-plus"></i> New
					</b-button>
				</b-col>
			</b-row>
			<div class="text-center w-100" v-if="false">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>

			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group v-if="false"
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							label-size="sm"
							class="mb-2 per-page-select"
						>
							<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
							<b-form-select
								id="per-page-select"
								class="diameter-report-select"
								v-model="perPage"
								:options="pageOptions"
								size="sm"
								v-on:input="changePageOption(perPage)"
							></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group v-if="false"
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<b-table
					v-if="previewDataClicked"
					striped
					hover
					:items="tableData"
					:fields="tableColumns"
					:current-page="currentPage"
					:per-page="perPage"
					:filter="filter"
					:filter-included-fields="filterOn"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					head-variant="light"
					table-class="text-nowrap"
					class="data-management-table primary-table"
					sticky-header="true"
					thead-class="white"
					show-empty
					responsive
					small
					@filtered="onFiltered"
				>
					
				</b-table>
				<b-row class="mt-4" v-if="previewDataClicked">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
			
			<b-modal 
				v-model="uploadModal" 
				hide-footer
				centered
				size="lg"
				id="upload-short-code"
				title="Upload Short Codes"
				class="Upload-Short-Code"
				:no-close-on-backdrop="true"
  				:no-close-on-esc="true"
			>
				<!-- Progress bar -->
				<b-progress :value="progress" :max="totalRows" :show-progress="false"></b-progress>
			</b-modal>

		</div>
	</transition>
</template>
<script>
import productManagementService from "../../../../common/api-services/product-management-service";

import handleResponse from "../../../../common/directive/handlResponse";
import TagsInput from "@/components/Inputs/TagsInput";
import pagination from '../../../../common/format/pagination'

import Papa from "papaparse";

export default {
	name: "NsimList",
	components: {TagsInput},
	data() {
		return {
			file1: null,
			previewDataClicked: false,
			show: "Show Data",
			usersForm: {
				group: [], //'Select Group',
			},
			groupOption: [],
			loadingStatus: false,
			totalRows: 0,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			perPage: 10,
			tableColumns: [
				{key: "dialed", label: "Dialed", sortable: true, sortDirection: "desc"},
				{key: "carrier", label: "Carrier", sortable: true, sortDirection: "desc"},
				{key: "carrier_code", label: "Carrier Code", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			localData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			uploadModal: false,
			progress: 0,
		};
	},
	mounted() {

	},
	methods: {

		changePageOption(page) {
			this.getTotalRows();
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},

		handleFileInputChange(event) {
			const file = event.target.files[0];

			// Check if a file was selected
			if (!file) {
				return;
			}

			// Read the file as text
			const reader = new FileReader();
			reader.onload = () => {
				const csvData = reader.result;
				this.parseCSV(csvData);
			};
			reader.readAsText(file);
			this.previewDataClicked = true;
		},
		parseCSV(csvData) {
			this.localData = [];
			this.totalRows = 0;
			this.tableData = [];
			// Parse the CSV data
			const parsedData = Papa.parse(csvData, { header: true }).data;
			// Map the parsed data to tableData
			parsedData.map(item => {
				let child = {
					dialed: item.dialed,
					carrier: item.carrier,
					carrier_code: item.carrier_code,
				};
				this.tableData.push(child);
			});
			this.localData = this.tableData;
			this.totalRows = this.tableData.length;
		},
		previewData() {
			// Call parseCSV when "Preview Data" button is clicked
			// this.parseCSV();
			// Set previewDataClicked to true to display the table
			this.previewDataClicked = true;
		},
		
		async downloadCsv(){
			const data = [
				['dialed', 'carrier', 'carrier_code'],
				[123456, 'Example', 9999],
				[654321, 'Carrier', 7777],
				// Add more rows here
			];

			const csvContent = Papa.unparse(data);

			// Create a Blob object to hold the CSV content
			const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

			// Create a URL for the Blob object
			const url = URL.createObjectURL(blob);

			// Create a download link and trigger the download
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'shortcode_template.csv');
			link.click();

			// Release the URL resource
			URL.revokeObjectURL(url);
		},

		async uploadCsv(){
			this.uploadModal = true;
			for (const item of this.tableData) {
				let payload = {
					dialed: item.dialed,
					to: item.to,
					nocache: 1,
				};
				const res = await productManagementService.InsertShortcodeData(payload);
				if (!res.includes('FAIL')) {
					this.progress++;
				}else{
					let {type, msg} = handleResponse.apiResponse(res);
					this.$toast(msg, {type: type})
				}
			};

			if(this.progress == this.totalRows){
				this.$toast('Upload Success', {type: 'success'});
				this.modalClose();
			}else{
				this.$toast('Some of the file did not upload', {type: 'error'});
				this.modalClose();
			}
			
		},

		modalClose() {
			this.$root.$emit('getShortCodeFunc');
			this.progress = 0;
			this.uploadModal = false;
		},
	},
	
};
</script>

<style>
#upload-short-code .close {
  display: none;
}
</style>
